import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./UserSlice"; // Make sure the path is correct

const store = configureStore({
  reducer: {
    auth: userReducer, // Use the correct key 'auth'
  },
});

export default store;
